import type { CookieT } from '~/types/cookie'

export const useUTMStore = defineStore('utm', () => {
  const utmState = ref<CookieT>()

  const getUtmState = computed(() => utmState.value)

  const setUtmState = (newCookie: Partial<CookieT>) => {
    utmState.value = {
      ...utmState.value,
      ...newCookie
    }
  }

  return {
    utmState,
    getUtmState,
    setUtmState
  }
})
